module.exports = __webpack_public_path__ + "img/shrimp_chart.e0a32c39.png";